import { render } from "./LocationRequestElement.vue?vue&type=template&id=37d17783&scoped=true"
import script from "./LocationRequestElement.vue?vue&type=script&lang=js"
export * from "./LocationRequestElement.vue?vue&type=script&lang=js"

import "./LocationRequestElement.vue?vue&type=style&index=0&id=37d17783&scoped=true&lang=css"

import exportComponent from "../../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d17783"]])

export default __exports__